import { TriangleAlert } from "lucide-react";
import React from "react";

import { Link } from "#/components/Link";
import { UserPagePath } from "#/lib/pagesHelper";

export function ThesisArchivedNote({ reason }) {
  return (
    <div className="bg-yellow-100 flex items-center p-4 border rounded-md w-full">
      <div className="w-full text-xs text-muted-foreground font-semibold">
        <div className="flex items-center gap-2">
          <TriangleAlert className="size-3 font-semibold" />
          <p className="m-0">
            Esta oportunidade se encontra arquivada e está no sistema para fins
            de consulta de informações. Seu oferecimento não é indicado.
          </p>
        </div>
        <p className="ml-5">Motivo da exclusão: {reason}</p>
      </div>
    </div>
  );
}

export function ThesesArchivedNote() {
  return (
    <div className="bg-yellow-100 flex items-center p-4 border rounded-md w-full">
      <div className="w-full text-xs text-muted-foreground font-semibold">
        <div className="flex items-center gap-2">
          <TriangleAlert className="size-3 font-semibold" />
          <p className="m-0">
            Algumas teses do diagnóstico inicial foram arquivadas e não costam
            mais na listagem abaixo.{" "}
            <Link to={UserPagePath.THESES} className="underline">
              Clique aqui para ver a relação de teses arquivadas no Recuperar.
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
